module.exports = __webpack_public_path__ + "img/PageLayoutNone.849929e8.png";